window.$ = window.jQuery = require("jquery");
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
import cookie from "js-cookie";
import Form from "./forms";
import toastr from "../utils/toastr";
import settings from "../utils/settings";
import "daterangepicker/daterangepicker";
import "select2/dist/js/select2.full.min";
import "select2/dist/js/i18n/ru";
import "../plugins/dropdown";
import { Util } from "bootstrap/js/dist/util";
import "bootstrap/js/dist/tooltip";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: global.sentry_dsn_js,
    tunnel: "/communication",
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });

  global.user && Sentry.setUser(global.user);
}

window.Util = Util;

(function ($) {
  $.fn.select2.defaults.set("language", "ru");

  $('[data-toggle="tooltip"]').tooltip({
    offset: "10, 10",
    delay: { show: 0, hide: 1000 },
  });

  $(".recaptcha-form").submit(function () {
    if ($(this).hasClass("blocked")) {
      return false;
    }
  });

  $(".js-datepicker").each(function () {
    $(this).daterangepicker(
      {
        autoApply: true,
        startDate: new Date($(this).data("from")),
        endDate: new Date($(this).data("to")),
        linkedCalendars: false,
      },
      (start, end, label) => {
        const $form = $(this).closest("form");

        $form.find(".js-date-from").val(start.format("DD.MM.YYYY"));
        $form.find(".js-date-to").val(end.format("DD.MM.YYYY"));
      }
    );
  });

  $("form").each(function () {
    new Form($(this));
  });

  $(".js-collapse-link").on("click", function (event) {
    event.preventDefault();

    const link = $(this);

    link.toggleClass("active");

    if (link.hasClass("active")) {
      link.text(link.data("in-text"));
    } else {
      link.text(link.data("out-text"));
    }

    link
      .closest(".b-inner")
      .find(".js-collapse")
      .slideToggle(settings.TRANSITION_SPEED);
  });

  $(".js-get-modal").on("click", function (event) {
    event.preventDefault();

    const target = $(this).data("target");

    $(target).trigger("open");
  });

  $(".b-modal").each(function () {
    const modal = $(this);

    modal
      .on("open", function () {
        modal.fadeIn(settings.TRANSITION_SPEED);
        $(document.body).addClass("fixed");
      })
      .on("close", function () {
        modal.fadeOut(settings.TRANSITION_SPEED, function () {
          $(document.body).removeClass("fixed");
        });
      })
      .on("click", function (event) {
        if (!$(event.target).closest(".b-modal__body").length) {
          modal.trigger("close");
        }
      });

    $(".js-dismiss-modal", modal).on("click", function (event) {
      event.preventDefault();
      modal.trigger("close");
    });
  });

  $(".b-inner").each(function () {
    const inner = $(this);
    const toggleItem = (toggler) => {
      const item = toggler.closest(".item");

      item.toggleClass("open");

      $(".sub-collapse", item).slideToggle(
        settings.TRANSITION_SPEED,
        function () {
          if (item.hasClass("open") && $(".open", inner).length > 1) {
            toggleItem($(".open", inner).not(item).find(".js-toggler"));
          }
        }
      );
    };

    $(".js-toggler", inner).on("click", function (event) {
      event.preventDefault();
      toggleItem($(this));
    });
  });

  $(
    ".b-dropdown:not(.js-dropdown-custom):not(.js-choice-widget):not(.user-menu)"
  ).dropdown();

  $(".b-dropdown.js-choice-widget").dropdown({
    mode: "switch",
    onItemClick: function () {
      $(this)
        .closest(".form-control")
        .find(".text-input")
        .val($(this).data("value"))
        .trigger("change");
    },
  });

  $(".b-dropdown.user-menu").dropdown({
    hideAfterTime: 1500,
    openedClass: "user-menu__opened",
  });

  $(".b-tabs").each(function () {
    const tabs = $(this);

    $(".js-tab-link", tabs).on("click", function (event) {
      event.preventDefault();

      const link = $(this);
      const target = link.data("target");
      const activeCollapse = $(".collapse.show", tabs);

      if (!link.hasClass("active")) {
        $(".js-tab-link.active", tabs).removeClass("active");
        link.addClass("active");
        activeCollapse.removeClass("show");
        $(target).addClass("show");
      }
    });
  });

  if (typeof window.flashes !== "undefined") {
    window.flashes.forEach(function (i) {
      toastr[i.type](i.message);
    });
  }

  $(".b-banner, .js-banner-block").each(function () {
    const banner = $(this);

    banner
      .on("close", () => {
        banner.slideUp(250, () => {
          banner.remove();
        });
      })
      .on("open", () => {
        banner.slideDown(450);
      });

    $(".js-banner-close", banner).on("click", function (event) {
      event.preventDefault();

      if (banner.hasClass("js-banner-block") && !!banner.data("banner-name")) {
        cookie.set(banner.data("banner-name") + "-banner-closed", "true");
      }

      banner.trigger("close");
    });
  });

  $(".js-user_id").on("click", function () {
    const $input = $("<input>");
    $("body").append($input);
    $input.val($.trim($(".js-user-id-value", this).text())).select();
    document.execCommand("copy");
    $input.remove();

    toastr.success($(this).data("success"));
  });

  $(".js-sidebar-toggler").click(() =>
    window.dispatchEvent(new Event("sidebar:toggle"))
  );
})(jQuery);
